import { default as MuiListItemText } from '@mui/material/ListItemText';

/**
 * ListItemText displays primary and secondary text within a ListItem.
 *
 * Demos:
 *
 * - [List](https://unify.workiva.org/components/list?tab=code)
 *
 * API:
 *
 * - [ListItemText API](https://unify.workiva.org/components/list?tab=props#listitemtext)
 */
export const ListItemText = MuiListItemText;
export {
  type ListItemTextProps,
  listItemTextClasses,
} from '@mui/material/ListItemText';
